import { render, staticRenderFns } from "./child-promotion-ghost-dialog.vue?vue&type=template&id=172d19ca&scoped=true"
import script from "./child-promotion-ghost-dialog.vue?vue&type=script&lang=js"
export * from "./child-promotion-ghost-dialog.vue?vue&type=script&lang=js"
import style0 from "./child-promotion-ghost-dialog.vue?vue&type=style&index=0&id=172d19ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d19ca",
  null
  
)

export default component.exports